// extracted by mini-css-extract-plugin
export default {"container":"SearchBox_container__fu1KY","input":"SearchBox_input__2Qjz6","clear":"SearchBox_clear__O51IP"};